import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import RealtorAgentInformation from "../../../components/loan_tools/forms/realtor_agent_information";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function RealtorAgentInformationRoute() {
  const [loanDoc, , , actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName
      ? `${lastName} – Realtor Agent Information`
      : "Realtor Agent Information";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  return (
    <StandardTemplate className="ba-template">
      {/* Back button is now provided by StandardTemplate for all ba-template forms. */}
      <RealtorAgentInformation />
    </StandardTemplate>
  );
}
